import { API } from 'api'
import {
	BodyCreateContent,
	BodySharedContent,
	BodySharedContentCopy,
	ContentListItem,
	ContentReachRequest,
	ContentReachResponse,
	CreateContentResponse
} from 'interfaces'
import { captureErrorSentry, SentryEvents, SentrySections } from 'utils/sentry'

export const postContentReach = async (
	body: ContentReachRequest
): Promise<ContentReachResponse | null> => {
	let res = null as ContentReachResponse | null
	await API()
		.post(`/contents/reach`, body)
		.then(
			async response => {
				res = response.data
			},
			error => {
				console.error(error)
			}
		)
	return res
}

export const postCreateContent = async (
	organizationId: number,
	body: BodyCreateContent | null
): Promise<CreateContentResponse | null> => {
	let res = null as CreateContentResponse | null
	await API()
		.post(`/contents/organizations/${organizationId}`, body)
		.then(
			async response => {
				res = response.data
			},
			error => {
				captureErrorSentry({
					section: SentrySections.CONTENT,
					event: SentryEvents.CREATE_CONTENT_ERROR,
					error,
					extra: {
						payload: body,
						organizationId
					}
				})

				if (error.response.data.detail) {
					res = { detail: error.response.data.detail }
				} else if (error.response.detail) {
					res = { detail: error.response.detail }
				}
			}
		)
	return res
}

export const postCopySharedContent = async (
	organizationId: number,
	body: BodySharedContentCopy,
	contentID: number
): Promise<CreateContentResponse | null> => {
	let res = null as CreateContentResponse | null
	await API()
		.post(
			`/contents/organization_partner/organizations/${organizationId}/partner_content/${contentID}/copy_content`,
			body
		)
		.then(
			async response => {
				res = response.data
			},
			error => {
				if (error.response.data.errors) {
					res = { detail: error.response.data.errors[0].msg }
				} else {
					res = { detail: error.response.data.detail.error }
				}
			}
		)
	return res
}

export const postCopySharedContentArray = async (
	organizationId: number,
	body: BodySharedContent
): Promise<CreateContentResponse | null> => {
	let res = null as CreateContentResponse | null
	await API()
		.post(
			`/contents/organization_partner/organizations/${organizationId}/bulk/copy_content`,
			body
		)
		.then(
			async response => {
				res = response.data
			},
			error => {
				if (error.response.data.errors) {
					res = { detail: error.response.data.errors[0].msg }
				} else {
					res = { detail: error.response.data.detail.error }
				}
			}
		)
	return res
}

export const duplicateContent = async (
	organizationId: number,
	contentID: number,
	withPushNotification: boolean
): Promise<ContentListItem | null> => {
	let res = null as ContentListItem | null
	await API()
		.post(
			`/contents/duplicate_content/${contentID}/organizations/${organizationId}`,
			{ duplicate_with_notification: withPushNotification }
		)
		.then(
			async response => {
				res = response.data
			},
			error => {
				captureErrorSentry({
					section: SentrySections.CONTENT,
					event: SentryEvents.DUPLICATE_CONTENT_ERROR,
					error,
					extra: {
						payload: { duplicate_with_notification: withPushNotification },
						organizationId,
						contentId: contentID
					}
				})
				console.error(error)
			}
		)
	return res
}
